import { useContext } from 'react';
import PurchaseContext from '../context/PurchaseContext';

const usePurchase = () => {
    return useContext(PurchaseContext);
};

export default usePurchase;